/**
 * DP4Y Mobile scroll focus fix
 * On iOS (and some Android browsers) a focused button/input can "snap" the page back to it while scrolling.
 * We gently blur focus while the user scrolls, but avoid blurring when the user is actively typing.
 */
(function () {
  try {
    var ua = navigator.userAgent || '';
    var isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
    if (!isMobile) return;

    var ticking = false;

    function shouldBlur(el) {
      if (!el || el === document.body) return false;

      var tag = (el.tagName || '').toUpperCase();
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') {
        // If user is typing, don't blur. (type text/email/tel/etc.)
        if (tag === 'TEXTAREA') return false;
        var type = (el.getAttribute('type') || '').toLowerCase();
        if (type && !['checkbox','radio','button','submit','reset'].includes(type)) return false;
      }

      // Avoid blurring cart note textarea
      if (el.closest && el.closest('textarea, .cart__note, [name="note"]')) return false;

      // If focus is on booster/upsell elements, blur to prevent scroll snapping
      if (el.closest && (el.closest('[class*="booster"]') || el.closest('[id*="booster"]'))) return true;

      // If it's a button/link (often "Bekijk extra's +"), blur
      if (tag === 'BUTTON' || tag === 'A') return true;

      // Default: do not blur
      return false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var ae = document.activeElement;
        if (shouldBlur(ae) && ae && typeof ae.blur === 'function') ae.blur();
      });
    }, { passive: true });
  } catch (e) {
    // silent
  }
})();
